import { render, staticRenderFns } from "./TabModalLimitTable.vue?vue&type=template&id=5721e860&scoped=true&"
import script from "./TabModalLimitTable.vue?vue&type=script&lang=js&"
export * from "./TabModalLimitTable.vue?vue&type=script&lang=js&"
import style0 from "./TabModalLimitTable.vue?vue&type=style&index=0&id=5721e860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721e860",
  null
  
)

export default component.exports